export default __webpack_public_path__ + "assets/images/b35db9a7d3ff1efee4ee8c017fe91071.svg";